import { layout } from '../../../tokens/tokens-base/properties/build/js/index.js';
import { isEmpty, isString, isObject } from '../../../_common/utils/common.js';
const LAYOUT_TOKENS = Object.keys(layout);
const getGapStitchesVariants = function (gap) {
  let layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'grid';
  if (isEmpty(gap)) {
    return {};
  }
  if (isGenericGap(gap)) {
    if (layout === 'flex') {
      // gap: 'none' | 'responsive' | SpacingToken | SpacingInnerToken
      return {
        genericGap: gap
      };
    }
    // gap: 'none' | 'responsive' | SpacingTokens
    return {
      genericGap: gap
    };
  }
  // gap: { vertical?: SpacingTokens | SpacingInnerTokens; horizontal?: SpacingTokens | SpacingInnerTokens; }
  if (isVerticalOrHorizontalGapWithoutBreakpoints(gap)) {
    return Object.assign(Object.assign({}, gap['vertical'] ? {
      verticalGap: gap['vertical']
    } : {}), gap['horizontal'] ? {
      horizontalGap: gap['horizontal']
    } : {});
  }
  // gap: { xs?: (...), sm?: (...), (...) }
  if (isGapWithBreakpoints(gap)) {
    let gapWithBreakpoints = {};
    // gap: { xs?: { vertical?: SpacingTokens; horizontal?: SpacingTokens; }, (...) }
    if (isVerticalOrHorizontalGapWithBreakpoints(gap)) {
      gapWithBreakpoints = LAYOUT_TOKENS.reduce((variants, breakpoint) => {
        var _a, _b;
        return Object.assign(Object.assign(Object.assign({}, variants), ((_a = gap[breakpoint]) === null || _a === void 0 ? void 0 : _a['vertical']) ? {
          [`${breakpoint}VerticalGap`]: gap[breakpoint]['vertical']
        } : {}), ((_b = gap[breakpoint]) === null || _b === void 0 ? void 0 : _b['horizontal']) ? {
          [`${breakpoint}HorizontalGap`]: gap[breakpoint]['horizontal']
        } : {});
      }, {});
    }
    // gap: { xs?: SpacingTokens, sm?: SpacingTokens, md?: SpacingTokens, (...) }
    return Object.assign(Object.assign({}, gapWithBreakpoints), LAYOUT_TOKENS.reduce((variants, breakpoint) => Object.assign(Object.assign({}, variants), gap[breakpoint] && typeof gap[breakpoint] === 'string' ? {
      [`${breakpoint}Gap`]: gap[breakpoint]
    } : {}), {}));
  }
  return {};
};
const isGenericGap = gap => isString(gap);
const isVerticalOrHorizontalGapWithBreakpoints = gap => {
  const GAP_KEYS = Object.keys(gap);
  return GAP_KEYS.some(key => gap[key]['vertical'] || gap[key]['horizontal']);
};
const isGapWithBreakpoints = gap => {
  if (!isObject(gap)) {
    return false;
  }
  const GAP_KEYS = Object.keys(gap);
  return GAP_KEYS.some(key => LAYOUT_TOKENS.includes(key));
};
const isVerticalOrHorizontalGapWithoutBreakpoints = gap => {
  if (!isObject(gap)) {
    return false;
  }
  return gap['vertical'] || gap['horizontal'];
};
export { getGapStitchesVariants };